import { ScopedCssBaseline } from '@mui/material'
import './index.css'
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication
} from '@azure/msal-browser'
import { loginRequest, msalConfig } from 'authConfig'
import ReactDOM from 'react-dom/client'
import { getAuthInfo } from 'utils/MsGraphApiCall'
import { App } from './App'
import { appInsights } from './config/appInsights'
import { setAccessTokenLocalStorageAndCookie } from 'utils/token'
import clarity from 'config/clarity'

clarity(process.env.REACT_APP_CLARITY_ID || '')

export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.addEventCallback(async (event: EventMessage) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  ) {
    const payload = event.payload as AuthenticationResult
    setAccessTokenLocalStorageAndCookie(payload)
    const account = payload.account
    msalInstance.setActiveAccount(account)
  }
})

// handle auth redired/do all initial setup for msal
msalInstance
  .handleRedirectPromise()
  .then(async authResult => {
    const account = msalInstance.getActiveAccount()
    if (!account) {
      msalInstance.loginRedirect(loginRequest)
    } else {
      msalInstance.setActiveAccount(account)
      const payload = await getAuthInfo()
      setAccessTokenLocalStorageAndCookie(payload)
    }
  })
  .catch(err => {
    appInsights.trackException(err)
  })

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ScopedCssBaseline>
    <App msalInstance={msalInstance} />
  </ScopedCssBaseline>
)
